var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "file-download", on: { click: _vm.downloadFile } },
    [
      _c(
        "div",
        { staticClass: "icon-wrapper" },
        [_c("file-icon", { attrs: { file: _vm.file } })],
        1
      ),
      _vm._v(" "),
      _c("div", { staticClass: "file-name" }, [_vm._v(_vm._s(_vm.file.name))]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }